import React, { useEffect, useState } from "react";
import HeroBannerSlider from "./HeroBannerSlider";
import OurSpeciality from "./OurSpeciality";
import OurDoctors from "./OurDoctors";
import WhyUs from "./WhyUs";
import AboutUs from "./AboutUs";
import PatientTestimonial from "./PatientTestimonial";
import FAQ from "./FAQ";
import NewsAndEvents from "./NewsAndEvents";
import Footer from "../Footer";
import Header from "../Header";

const HomePage = () => {
  return (
    <>
      <Header/>
      <HeroBannerSlider />
      <OurSpeciality/>
      <AboutUs/>
      <OurDoctors/>
      <WhyUs/>
      <PatientTestimonial/>
      <FAQ/>
      <NewsAndEvents/>
      <Footer/>
    </>
  );
};

export default HomePage;